<script lang="ts">
  import AuthLayout from "./auth/AuthLayout.svelte";
  import Button from "$lib/components/Button.svelte";
</script>

<AuthLayout title="Page not found" subtitle="That page doesn't exist or you don't have access.">
  <Button href="/" fullWidth>Go to your portal</Button>
</AuthLayout>
